import React, { PureComponent } from 'react';
import _ from 'lodash';
import { Icon } from 'antd';
import { Link } from 'react-router-dom';
import { Image, BackgroundImage } from '../../components';
import { withRedux } from '../../hoc';
import { getServiceUrl } from '../../utils';
import { addWishlistAction, removeWishlistAction } from '../../actions/quotes';

const mapStateToProps = state => {
  return {
    t: _.get(state, 't'),
    languages: _.get(state, 'languages'),
    quotes: _.get(state, 'quotes')
  };
};

const actions = {
  addWishlistAction,
  removeWishlistAction
};

@withRedux(mapStateToProps, actions)
export default class ProductItemGrid extends PureComponent {
  handleClickWishlist = id => {
    if (this.alreadyWishlist()) {
      this.props.actions.removeWishlistAction(id);
    } else {
      this.props.actions.addWishlistAction(id);
    }
  };
  alreadyWishlist = () => {
    return _.includes(this.props.quotes.wishlist, this.props.id);
  };
  render() {
    const { id, image, name, category, brand, functions, media_catalog_id_data, t } = this.props;
    const product_full_file_path = `${getServiceUrl()}/${_.get(image, 'path')}`;
    const brand_full_file_path = `${getServiceUrl()}/${_.get(brand, 'logo.path')}`;
    const media_catalog_full_file_path = `${getServiceUrl()}/${_.get(t(media_catalog_id_data), 'path')}`;
    return (
      <div className="product-item grid">
        <Link to={`/product/detail/${id}`}>
          <div className="product-image">
            <BackgroundImage image={product_full_file_path} />
          </div>
          <div className="detail">
            <div className="with-brand">
              <div className="left">
                <div className="name">
                  {t('Name')}: {t(name)}
                </div>
                {/* <div className="model">Models: {t(model)}</div> */}
                <div className="category">
                  {t('Category')}: {t(_.get(category, 'name'))}
                </div>
              </div>
              <div className="right">
                <div className="logo-brand">
                  <Image src={brand_full_file_path} alt={t(_.get(brand, 'name'))} />
                </div>
              </div>
            </div>
            <div className="guide">
              {t('Functions')}: {t(functions)}
            </div>
          </div>
        </Link>
        <div className="action">
          <a href={media_catalog_full_file_path} target="_blank" className="left">
            <div className="icon download">
              <Icon type="download" />
            </div>
            <div className="label">{t('Catalog')}</div>
          </a>
          <div className="right">
            <div
              className={`icon wishlist ${this.alreadyWishlist() ? 'active' : ''}`}
              onClick={() => this.handleClickWishlist(id)}
            >
              <Icon type="heart" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProductItem/Grid.js